import { render, staticRenderFns } from "./contratos.view.vue?vue&type=template&id=05eb8e45"
import script from "./contratos.view.vue?vue&type=script&lang=js"
export * from "./contratos.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports